import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-98">
      <div className="container mx-auto px-4" data-id="element-99">
        {/* Swedenmark Group block */}
        <div className="mb-12" data-id="element-100">
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-6" data-id="element-101">
            Part of the Swedenmark Group
          </p>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-102">
            <div className="p-6 rounded-lg border border-gray-800 bg-gray-900/40" data-id="element-103">
              <div className="flex items-center mb-3" data-id="element-104">
                <span className="text-lg tracking-tight flex items-center whitespace-nowrap" data-id="element-105">
                  <span className="font-bold text-white" data-id="element-106">swedenmark</span>
                  <span className="mx-0.5 text-xl leading-none translate-y-[-1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-400" data-id="element-107">
                    &bull;
                  </span>
                  <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-400" data-id="element-108">
                    studio
                  </span>
                </span>
              </div>
              <p className="text-gray-400 text-sm mb-2" data-id="element-109">
                Custom software & product builds
              </p>
              <p className="text-xs text-gray-500" data-id="element-110">You are here</p>
            </div>
            <a href="https://www.swedenmark.ai" target="_blank" rel="noopener noreferrer" className="group p-6 rounded-lg border border-gray-800 bg-gray-900/40 hover:border-gray-600 hover:bg-gray-800/40 transition-colors" data-id="element-111">
              <div className="flex items-center justify-between mb-3" data-id="element-112">
                <span className="text-lg tracking-tight flex items-center whitespace-nowrap" data-id="element-113">
                  <span className="font-bold text-white" data-id="element-114">swedenmark</span>
                  <span className="mx-0.5 text-xl leading-none translate-y-[-1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500" data-id="element-115">
                    &bull;
                  </span>
                  <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500" data-id="element-116">
                    ai
                  </span>
                </span>
                <ArrowUpRightIcon size={18} className="text-gray-500 group-hover:text-white transition-colors" data-id="element-117" />
              </div>
              <p className="text-gray-400 text-sm mb-2" data-id="element-118">
                AI automation & growth consulting
              </p>
              <p className="text-xs text-gray-500" data-id="element-119">swedenmark.ai →</p>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-120">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-121">
            &copy; {new Date().getFullYear()} Swedenmark Studio. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-400" data-id="element-122">
            <a href="#" className="hover:text-white transition-colors" data-id="element-123">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-124">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-125">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}